import React, { Component } from 'react'
import { action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import * as R from 'ramda'

import CheckboxCol from './CheckboxCol'
import Input from '../../form/Input'
import configFormInputType from '../configFormOptions/configFormInputType'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'

@observer
class DefaultSlideConfig extends Component {
    constructor(props) {
        super(props)
        const { presentationStore, config } = props
        const { question, slide } = config
        const { questionTypeCode } = question
        this.questionOptions = presentationStore.getConfigFormOptions(questionTypeCode, question, {})
        this.slide = slide
        this.defaultSelectValues = []
        this.presentationStore = presentationStore
        makeObservable(this.slide)
    }

    onChangeHandler = ({ value, name }) => {
        this.slide[name] = value
        console.log(JSON.stringify(this.slide, null, 4))
    }

    @action
    updatePowerpointObject = (fieldName, {
        name,
        value,
    }) => {
        console.log('updatePowerpointObject', fieldName, name, value)
        if (['locked'].includes(fieldName)) {
            this.slide[fieldName] = value
        } else if (fieldName === 'comparisonSurveyIds') {
            this.slide.comparisonSurveyIds = this.slide.comparisonSurveyIds
                .slice()
                .map((benchmark) => {
                    if (benchmark.value === name) {
                        benchmark.checked = value
                    }
                    return benchmark
                })
        } else if (fieldName === 'benchmarks') {
            this.slide.benchmarks = this.slide.benchmarks
                .slice()
                .map((benchmark) => {
                    if (benchmark.value === name) {
                        benchmark.checked = value
                    }
                    return benchmark
                })
        }
    }

    getValue = ({ value, name }) => {
        const {
            config,
        } = this.props
        config.powerPointObj[name] = value
    }

    setBoolean = ({ value, name }) => {
        this.slide[name] = value
    }

    renderGeneralSettings = () => {
        const { presentationStore, questionOptions } = this
        const general = questionOptions.filters.filter(({ groupId }) => groupId === 'general')

        if (general.length === 0) return null

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBlock: 8 }}>
                {general.map(({ name, options }) => (
                    <Select
                        key={`general_${name}`}
                        label={presentationStore.getSelectLabel(name)}
                        options={options}
                        onBlur={this.onChangeHandler}
                        defaultValue={this.slide[name]}
                    />
                ))}
            </div>
        )
    }

    renderOptional = (optionalSettings) => {
        if (optionalSettings.length === 0) return null

        return (
            <div className="checkbox-cols">
                <p className="optionHeaders">Optional Settings</p>
                {optionalSettings}
            </div>
        )
    }

    render() {
        const {
            config,
        } = this.props
        /**
         * build years select options from yearsQuestionWasAsked or globalYears prop
         */
        const { benchmarks, comparisonSurveyIds } = this.slide
        const markup = []
        const optionalSettings = []
        const genaralSettings = []
        if (R.hasPath(['filters'], this.questionOptions)) {
            this.questionOptions.filters.forEach((filter, i) => {
                const { inputType } = configFormInputType[filter.name]
                switch (inputType) {
                    case 'checkbox':
                        markup.push(
                            <CheckboxCol
                                callback={this.updatePowerpointObject}
                                key={i}
                                id={`checkbox_${this.slide.id}`}
                                config={config}
                                title={i18n.t(`powerpoint.labels.${filter.name}`)}
                                name={filter.name}
                                grid={{ xs: 1 }}
                                checkboxes={filter.options}
                            />,
                        )
                        break
                    case 'checkbox:years':
                        if (this.slide.hasComparisons) {
                            markup.push(
                                <CheckboxCol
                                    callback={this.updatePowerpointObject}
                                    key={i}
                                    config={config}
                                    id={`years_${this.slide.id}`}
                                    name={filter.name}
                                    title="Select years"
                                    grid={{ xs: 1 }}
                                    checkboxes={comparisonSurveyIds}
                                    cssClass="checkbox-cols"
                                />,
                            )
                        }
                        break
                    case 'checkbox:benchmarks':
                        if (this.slide.hasBenchmarks) {
                            console.log('checkbox:benchmarks', `benchmarks_${this.slide.id}`)
                            markup.push(
                                <CheckboxCol
                                    callback={this.updatePowerpointObject}
                                    key={`benchmarks_${this.slide.id}`}
                                    id={`benchmarks_${this.slide.id}`}
                                    name={filter.name}
                                    config={config}
                                    title="Select Benchmarks"
                                    grid={{ xs: 1 }}
                                    checkboxes={benchmarks}
                                    cssClass="checkbox-cols exploriNativeCheckbox"
                                />,
                            )
                        }
                        break
                    case 'checkbox:boolean':
                        optionalSettings.push(
                            <Checkbox
                                name={filter.name}
                                label={filter.label}
                                checked={this.slide[filter.name]}
                                onBlur={this.setBoolean}
                                className="exploriNativeCheckbox"
                            />,
                        )
                        break
                    case 'text:int':
                        markup.push(
                            <Col key={i} xs={2}>
                                <Input
                                    name={filter.name}
                                    type="number"
                                    onBlur={this.getValue}
                                    key={i}
                                    label={i18n.t(`powerpoint.labels.${filter.name}`)}
                                    cssClass="number-input"
                                />
                            </Col>,
                        )
                        break
                    default:
                        break
                }
            })
            if (genaralSettings.length > 0) {
                const temp = []
                temp.push(
                    <div className="question-select-col">
                        {genaralSettings}
                    </div>,
                )
                markup.unshift(...temp)
            }
        }
        return (
            <React.Fragment>
                {this.renderGeneralSettings()}
                {this.renderOptional(optionalSettings)}
                {markup}
            </React.Fragment>
        )
    }
}

/**
 * @param {string} [references.questionId]      - (optional)
 * @param {string} [references.pageQuestionId]  - (optional)
 * @param {string} [references.kpiId]           - (optional)
 */

DefaultSlideConfig.propTypes = {
    config: PropTypes.object.isRequired,
    questionTypeCode: PropTypes.string.isRequired,
}

export default DefaultSlideConfig
